import React from 'react';
import Modal from '$/components/Modal';
import classNames from 'classnames';

import styles from './index.module.scss';

interface ActivityPopupInfoProps {
  open: boolean;
  image: string;
  closeBtnPosition?: 'topRight' | 'bottomCenter';
  maskClosable?: boolean;
  onClose: () => void;
  onImageClick: () => void;
}

export default function ActivityPopup({
  open,
  image,
  closeBtnPosition = 'bottomCenter',
  maskClosable = false,
  onClose,
  onImageClick,
}: ActivityPopupInfoProps) {
  return (
    <Modal
      open={open}
      width="auto"
      onCancel={onClose}
      wrapClassName={styles.ActivityPopupWrapper}
      bodyClassName={styles.ActivityPopup}
      maskStyle={{
        background: 'var(--background-backgroundMaskPrimary, rgba(15, 15, 15, 0.90))',
      }}
      destroyOnClose
      closable={false}
      maskClosable={maskClosable}
    >
      <div className={styles.content}>
        <img className={styles.img} src={image} alt="" onClick={onImageClick} />
        <div
          className={
            classNames(styles.closeBtn, closeBtnPosition === 'topRight' ? styles.closeBtnTopRight : styles.closeBtnBottomCenter)
            }
          onClick={onClose}
        />
      </div>
    </Modal>
  );
}
